export const drawResult = (result, scoreType) => {
  const { calculated_score } = result;
  const c = document.getElementById('risk-canvas1');

  const startX = scoreType === 'TR' ? 238 : 355;
  const endX = scoreType === 'TR' ? 1672 : 1655;
  const height = scoreType === 'TR' ? 1180 : 1208;

  drawLine({
    canvas: c,
    lineHeight: height,
    calculated_score,
    canvasSize: { width: 1758, height: 1502 },
    startX,
    endX,
  });

  if (scoreType === 'SMR') {
    const c2 = document.getElementById('risk-canvas2');
    const lh = 960;
    const config = {
      canvas: c2,
      lineHeight: lh,
      calculated_score,
      canvasSize: { width: 1756, height: 1102 },
    };

    if (calculated_score < 49) {
      config.lineHeight = lh / 2;
      config.yOffset = lh / 2;
    }
    drawLine(config);
  }
};

export const drawLine = (config) => {
  const {
    canvas,
    lineHeight,
    yOffset = 0,
    calculated_score,
    canvasSize,
    startX,
    endX,
  } = config;
  const { width, height } = canvasSize;
  canvas.width = width;
  canvas.height = height;

  const valPercent = parseFloat(calculated_score) / 100;
  let xpos;
  let offsetY;
  let heightPx;

  if (startX !== undefined && endX !== undefined) {
    xpos = startX + valPercent * (endX - startX);
    offsetY = yOffset;
    heightPx = lineHeight;
  } else {
    const maxX = 1296;
    const imageScale = width / 1758;
    const xoffset = 360 * imageScale;
    xpos = valPercent * (imageScale * maxX) + xoffset;
    offsetY = yOffset * imageScale;
    heightPx = lineHeight * imageScale;
  }

  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, width, height);
  ctx.beginPath();
  ctx.moveTo(xpos, offsetY);
  ctx.lineTo(xpos, Math.round(heightPx) + offsetY);
  ctx.lineWidth = 5;
  ctx.strokeStyle = 'red';
  ctx.stroke();

  ctx.fillStyle = 'rgba(255, 0, 0, 0.5)';
  ctx.font = '40px sans-serif';
  ctx.fillRect(xpos - 240, Math.round(heightPx) + offsetY - 100, 240, 67);
  ctx.fillStyle = 'white';
  ctx.fillText('Your Patient', xpos - 230, Math.round(heightPx) + offsetY - 50);
};
